import {Component, input, output} from '@angular/core';
import {typeOfVisitList} from '@employee-pages/badge-request-page/non-deloitte-visitors/non-deloitte.const';
import {UIComponentsModule} from '@ui-app/app.module';
import {BaseFieldComponent} from '@employee-pages/shared/components/fields-for-forms/base-field.component';

@Component({
    selector: 'employee-visitor-type',
    standalone: true,
    imports: [
        UIComponentsModule
    ],
    templateUrl: './visitor-type.component.html',
    styleUrl: './visitor-type.component.less'
})
export class VisitorTypeComponent extends BaseFieldComponent {
    controlKey = input('typeOfVisit');
    disabled = input(false);
    visitorTypeChange = output()
    protected readonly typeOfVisitList = typeOfVisitList;

    protected onSelectionChange(value: string): void {
        const reasonId = this.typeOfVisitList.find(item => item.name === value).id;
        this.parentForm.patchValue({
            [this.controlKey()]: reasonId,
        });
        this.visitorTypeChange.emit()
    }

    protected initControl(): void {
        this.selectedValue = this.typeOfVisitList.find(item => item.id === this.defaultValue)?.name;
        super.initControl();
    }

}
